"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var messages = (0, _reactIntl.defineMessages)({
  privacy: {
    "id": "privacy",
    "defaultMessage": "Privacy"
  },
  view: {
    "id": "view",
    "defaultMessage": "View"
  },
  manage: {
    "id": "manage",
    "defaultMessage": "Manage"
  },
  privacyPolicy: {
    "id": "Login.privacyPolicy",
    "defaultMessage": "Privacy policy"
  },
  readMoreDataCollection: {
    "id": "readMoreDataCollection",
    "defaultMessage": "Read more about how SwipeGuide collects and processes your personal data."
  },
  cookiePreferences: {
    "id": "cookiePreferences",
    "defaultMessage": "Cookie preferences"
  },
  manageYourCookiePreferences: {
    "id": "manageYourCookiePreferences",
    "defaultMessage": "Manage your cookie preferences. Read more about the way SwipeGuide uses cookies in our {cookieStatementLink}."
  },
  cookieStatement: {
    "id": "cookieStatement",
    "defaultMessage": "Cookie statement"
  }
});
var _default = exports["default"] = messages;
//# sourceMappingURL=messages.js.map